import { DestroyRef, inject, signal } from '@angular/core';
import { FormServiceSaveHandlerSubmitOnlyApiItem, FsOnAfterSaveEvent, ModelFormServiceFactory } from '@common/forms/frontend-shared';
import { InputDropdownInstruction, InputTextareaInstruction, InputTextInstruction } from '@common/instructions/frontend-shared';
import { takeWhileAlive } from '@core/frontend-shared';
import { AppRequestService } from '@core/frontend-shared/api';
import { DemoRequestItem, getContactSourceOptions } from '@mpf/contact/shared';
import { DynamicFieldsetModule } from '@common/forms/frontend-shared';
import { MinimalUiModule } from '@common/ui/frontend-shared';
import { UiRequiredModule } from '@mpf/ui/frontend-shared/ui-required.module';
import { RouterLink } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared/api";
import * as i2 from "@common/forms/frontend-shared";
import * as i3 from "../../../../../common/ui/frontend-shared/src/lib/button/button";
import * as i4 from "../../../../../common/ui/frontend-shared/src/lib/message/message";
import * as i5 from "../../../../../common/forms/frontend-shared/src/lib/simple-fieldset/simple-fieldset.component";
import * as i6 from "../../../../../common/forms/frontend-shared/src/lib/form-submit-button/form-submit-button.directive";
function ContactDemoRequestComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "simple-fieldset", 1);
    i0.ɵɵelementStart(1, "div", 2)(2, "p")(3, "small");
    i0.ɵɵtext(4, "Ihre angegebenen Daten werden gespeichert und zur Kontaktaufnahme und Accounterstellung verwendet. ");
    i0.ɵɵelementStart(5, "a", 3);
    i0.ɵɵtext(6, "Datenschutz");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(7, "button", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formService", ctx_r0.service)("instructions", ctx_r0.instructions);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLink", "/privacy");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formSubmitButton", ctx_r0.service);
  }
}
function ContactDemoRequestComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 0)(1, "p");
    i0.ɵɵtext(2, "Vielen Dank f\u00FCr Ihre Anfrage. Unsere Mitarbeiter bearbeiten diese und melden sich zeitnah bei Ihnen.");
    i0.ɵɵelementEnd()();
  }
}
export let ContactDemoRequestComponent = /*#__PURE__*/(() => {
  class ContactDemoRequestComponent {
    constructor(api, formServiceFactory) {
      this.api = api;
      this.destroyRef = inject(DestroyRef);
      this.instructions = [new InputTextInstruction({
        formControlName: 'name',
        placeholder: 'Vor- und Nachname'
      }), new InputTextInstruction({
        formControlName: 'company',
        placeholder: 'Unternehmen / Einrichtung'
      }), new InputTextInstruction({
        formControlName: 'email',
        placeholder: 'Ihre E-Mail-Adresse'
      }), new InputTextInstruction({
        formControlName: 'phone',
        placeholder: 'Telefonnr.'
      }), new InputDropdownInstruction({
        formControlName: 'source',
        placeholder: 'Wie wurden Sie auf uns aufmerksam?',
        options: getContactSourceOptions()
      }), new InputTextareaInstruction({
        formControlName: 'message',
        height: 2,
        autoResize: true,
        placeholder: 'Nachricht (optional)'
      })];
      this.demoRequestCompleted = signal(false, ...(ngDevMode ? [{
        debugName: "demoRequestCompleted"
      }] : /* istanbul ignore next */[]));
      this.service = formServiceFactory.useDestroyRef(this.destroyRef).createModelForm(DemoRequestItem);
      this.service.setSaveHandler(FormServiceSaveHandlerSubmitOnlyApiItem);
      this.service.events$.pipe(
      // filter(e=>e instanceof FsOnAfterSaveEvent),
      takeWhileAlive()).subscribe(e => {
        if (!(e instanceof FsOnAfterSaveEvent)) return;
        if (!e.error) {
          this.demoRequestCompleted.set(true);
        }
      });
      this.service.initialize();
    }
    static {
      this.ɵfac = function ContactDemoRequestComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContactDemoRequestComponent)(i0.ɵɵdirectiveInject(i1.AppRequestService), i0.ɵɵdirectiveInject(i2.ModelFormServiceFactory));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: ContactDemoRequestComponent,
        selectors: [["mpf-contact-demo-request"]],
        decls: 2,
        vars: 1,
        consts: [["type", "success"], [3, "formService", "instructions"], [1, "ui-margin"], [3, "routerLink"], ["uiButton", "", "label", "Senden", 3, "formSubmitButton"]],
        template: function ContactDemoRequestComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, ContactDemoRequestComponent_Conditional_0_Template, 8, 4)(1, ContactDemoRequestComponent_Conditional_1_Template, 3, 0, "ui-message", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.demoRequestCompleted() ? 0 : 1);
          }
        },
        dependencies: [UiRequiredModule, i3.UiButtonComponent, i4.UiMessageComponent, MinimalUiModule, DynamicFieldsetModule, i5.SimpleFieldsetComponent, i6.FormSubmitButtonDirective, RouterLink],
        encapsulation: 2
      });
    }
  }
  return ContactDemoRequestComponent;
})();